/* Two-step UI only. Shrine owns timing, persistence, customer form and success. */
(() => {
  function enhance(root) {
    if (root.dataset.welcomeReady) return;
    const modal = root.querySelector('.sign-up-popup-modal');
    const intro = root.querySelector('[data-welcome-intro]');
    const email = root.querySelector('[data-welcome-email]');
    const next = root.querySelector('[data-welcome-next]');
    const back = root.querySelector('[data-welcome-back]');
    const close = modal?.querySelector('.popup-modal__close');
    if (!modal || !intro || !email || !next || !back || !close) return;
    root.dataset.welcomeReady = 'true';
    let previousFocus = null;
    let wasOpen = modal.classList.contains('popup-modal--active');

    function showEmail(focus) {
      intro.hidden = true;
      email.hidden = false;
      back.hidden = false;
      next.setAttribute('aria-expanded', 'true');
      if (focus) email.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    }
    function showIntro(focus) {
      intro.hidden = false;
      email.hidden = true;
      back.hidden = true;
      next.setAttribute('aria-expanded', 'false');
      if (focus) next.focus({ preventScroll: true });
    }
    next.addEventListener('click', () => showEmail(true));
    back.addEventListener('click', () => showIntro(true));
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close.click();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = [...modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')]
        .filter((node) => node.getClientRects().length && !node.closest('[hidden]'));
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    });
    const hasError = () => !!email.querySelector('[aria-invalid="true"]');
    if (hasError()) {
      showEmail(false);
      // Preserve the native server validation state even after a previous
      // visit's normal popup frequency has been recorded.
      modal.classList.add('popup-modal--active');
      root.querySelector('.sign-up-popup-overlay')?.classList.add('popup-overlay--active');
    } else {
      showIntro(false);
    }
    const observer = new MutationObserver(() => {
      const isOpen = modal.classList.contains('popup-modal--active');
      if (isOpen && !wasOpen) {
        previousFocus = document.activeElement;
        if (hasError()) showEmail(true);
        else { showIntro(false); close.focus({ preventScroll: true }); }
      } else if (!isOpen && wasOpen) {
        showIntro(false);
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }
      wasOpen = isOpen;
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    if (wasOpen) close.focus({ preventScroll: true });
  }
  // Native success-testing renders its modal without the posted-form script.
  // Only add close/focus behavior; customer submission and storage stay native.
  function enhanceSuccess(modal) {
    if (modal.dataset.welcomeSuccessReady) return;
    const close = modal.querySelector('.popup-modal__close');
    const dismiss = modal.querySelector('.popup-modal__dismiss-btn');
    const overlay = modal.parentElement?.querySelector('.success-popup-overlay');
    if (!close) return;
    modal.dataset.welcomeSuccessReady = 'true';
    let wasOpen = modal.classList.contains('popup-modal--active');
    let previousFocus = wasOpen ? document.activeElement : null;
    function closeSuccess() {
      modal.classList.remove('popup-modal--active');
      overlay?.classList.remove('popup-overlay--active');
    }
    close.addEventListener('click', closeSuccess);
    dismiss?.addEventListener('click', closeSuccess);
    overlay?.addEventListener('click', closeSuccess);
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSuccess();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = [...modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')]
        .filter((node) => node.getClientRects().length && !node.closest('[hidden]'));
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    });
    const observer = new MutationObserver(() => {
      const isOpen = modal.classList.contains('popup-modal--active');
      if (isOpen && !wasOpen) {
        previousFocus = document.activeElement;
        close.focus({ preventScroll: true });
      } else if (!isOpen && wasOpen && previousFocus?.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
      wasOpen = isOpen;
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    if (wasOpen) close.focus({ preventScroll: true });
  }
  function init(scope = document) {
    scope.querySelectorAll('promo-popup[data-ruolai19-welcome="true"]').forEach(enhance);
    scope.querySelectorAll('.success-popup-modal.ruolai19-welcome-modal').forEach(enhanceSuccess);
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
